// src/services/jobs.js
import { supabase } from '../lib/supabaseClient'

/**
 * 현재 로그인한 유저 정보 가져오기
 */
async function getCurrentUser() {
  const { data: { user }, error } = await supabase.auth.getUser()
  if (error) throw error
  return user
}

/**
 * 약국이 공고 생성
 */
export async function createJobPost(payload) {
  const user = await getCurrentUser()

  // created_by = 현재 로그인한 약국 user.id
  const insertData = {
    ...payload,
    created_by: user.id
  }

  const { data, error } = await supabase
    .from('job_posts')
    .insert(insertData)
    .select()
    .single()

  if (error) throw error
  return data
}

/**
 * 약국이 공고 수정
 */
export async function updateJobPost(id, payload) {
  const user = await getCurrentUser()

  const { data, error } = await supabase
    .from('job_posts')
    .update(payload)
    .eq('id', id)
    .eq('created_by', user.id)  // 본인 공고만 수정 가능
    .select()
    .single()

  if (error) throw error
  return data
}

/**
 * 약국이 본인이 등록한 공고 목록 가져오기
 */
export async function getMyPharmacyJobs() {
  const user = await getCurrentUser()

  const { data, error } = await supabase
    .from('job_posts')
    .select('*')
    .eq('created_by', user.id)
    .order('created_at', { ascending: false })

  if (error) throw error
  return data
}

/**
 * 약국이 본인 공고 삭제
 */
export async function deleteJobPost(id) {
  const user = await getCurrentUser()

  const { error } = await supabase
    .from('job_posts')
    .delete()
    .eq('id', id)
    .eq('created_by', user.id)

  if (error) throw error
  return true
}

/**
 * 약사 화면: 모든 open 공고 불러오기 (캘린더용)
 */
export async function listOpenJobs() {
  const { data, error } = await supabase
    .from('job_posts')
    .select('*')
    .eq('status', 'open')
    .order('date', { ascending: true })

  if (error) throw error
  return data
}

/* -----------------------------------------
   ADMIN FUNCTIONS
-------------------------------------------- */

/**
 * 관리자: 전체 공고 조회
 */
export async function adminListJobs() {
  const { data, error } = await supabase
    .from('job_posts')
    .select(`
      *,
      pharmacy:created_by (
        display_name,
        email
      )
    `)
    .order('created_at', { ascending: false })

  if (error) throw error
  return data
}

/**
 * 관리자: 공고 상태 일괄 업데이트
 */
export async function adminBulkUpdateJobsStatus(ids, status) {
  const { data, error } = await supabase
    .from('job_posts')
    .update({ status })
    .in('id', ids)
    .select()

  if (error) throw error
  return data
}

/**
 * 관리자: 공고 일괄 삭제
 */
export async function adminBulkDeleteJobs(ids) {
  const { error } = await supabase
    .from('job_posts')
    .delete()
    .in('id', ids)

  if (error) throw error
  return true
}

/**
 * 관리자: 지원 목록 조회
 */
export async function adminListApplications() {
  const { data, error } = await supabase
    .from('applications')
    .select(`
      *,
      job_posts (
        title,
        date,
        time,
        region,
        district,
        location
      ),
    `)
    .order('created_at', { ascending: false })

  if (error) throw error
  return data
}

/**
 * 관리자: 지원 상태 일괄 업데이트
 */
export async function adminBulkUpdateApplicationsStatus(ids, status) {
  const { data, error } = await supabase
    .from('applications')
    .update({ status })
    .in('id', ids)
    .select()

  if (error) throw error
  return data
}
